module.exports = __webpack_public_path__ + "static/media/one-off-sale.abcba9a0.svg";